import { SuccessDesktop } from './SuccessDesktop'
import { SuccessMobile } from './SuccessMobile'
import { isDesktop } from 'react-device-detect'

function SuccessComponent(props: any) {
  return isDesktop ? <SuccessDesktop {...props} /> : <SuccessMobile {...props} />
}

export default SuccessComponent